var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5H19C19.3034 5.00023 19.6026 5.06951 19.8752 5.20251C20.1479 5.33552 20.3868 5.52882 20.5737 5.76776C20.7606 6.0067 20.8906 6.28501 20.9541 6.58167C21.0176 6.87832 21.0127 7.18554 20.9399 7.48004L19.9399 13.48C19.8327 13.9136 19.5835 14.2989 19.2319 14.5743C18.8803 14.8498 18.4467 14.9997 18 15H6C5.46957 15 4.96077 14.7893 4.58569 14.4142C4.21062 14.0392 4 13.5304 4 13V5C4 4.46957 3.78914 3.96089 3.41406 3.58582C3.03899 3.21074 2.53043 3 2 3H1",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5H19C19.3034 5.00023 19.6026 5.06951 19.8752 5.20251C20.1479 5.33552 20.3868 5.52882 20.5737 5.76776C20.7606 6.0067 20.8906 6.28501 20.9541 6.58167C21.0176 6.87832 21.0127 7.18554 20.9399 7.48004L19.9399 13.48C19.8327 13.9136 19.5835 14.2989 19.2319 14.5743C18.8803 14.8498 18.4467 14.9997 18 15H6C5.46957 15 4.96077 14.7893 4.58569 14.4142C4.21062 14.0392 4 13.5304 4 13V5ZM4 5C4 4.46957 3.78914 3.96089 3.41406 3.58582C3.03899 3.21074 2.53043 3 2 3H1",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 20C6 19.4477 6.44772 19 7 19C7.55229 19 8.00001 19.4477 8.00001 20C8.00001 20.5523 7.55229 21 7 21C6.44772 21 6 20.5523 6 20ZM7 17C5.34315 17 4 18.3431 4 20C4 21.6569 5.34315 23 7 23C8.65685 23 10 21.6569 10 20C10 18.3431 8.65685 17 7 17ZM16 20C16 19.4477 16.4477 19 17 19C17.5523 19 18 19.4477 18 20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20ZM17 17C15.3431 17 14 18.3431 14 20C14 21.6569 15.3431 23 17 23C18.6569 23 20 21.6569 20 20C20 18.3431 18.6569 17 17 17Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlack);
export default __webpack_public_path__ + "static/media/cartBlack.2e82ccb69afa8b1e3936d9bd4efd7bbd.svg";
export { ForwardRef as ReactComponent };